// src/lib/goals.js
// Pure, Firebase-free helpers for weekly goals & the weekly leaderboard.
// A "week" is ISO-8601: weeks start on Monday and the first week of a year is
// the one containing its first Thursday.

export const DEFAULT_WEEKLY_GOAL = 500;

// Monday 00:00 (local time) of the week containing `date`.
export function startOfWeek(date = new Date()) {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  // getDay(): 0=Sun..6=Sat → shift so Monday is the first day.
  const day = (d.getDay() + 6) % 7;
  d.setDate(d.getDate() - day);
  return d;
}

// Stable ISO-week key, e.g. "2026-W26". Sorts/compares as a plain string.
export function weekKey(date = new Date()) {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  // Thursday of the current week decides the ISO year & week number.
  const day = (d.getDay() + 6) % 7;
  d.setDate(d.getDate() - day + 3);
  const isoYear = d.getFullYear();
  const firstThursday = new Date(isoYear, 0, 4);
  const firstDay = (firstThursday.getDay() + 6) % 7;
  firstThursday.setDate(firstThursday.getDate() - firstDay + 3);
  const week = 1 + Math.round((d - firstThursday) / (7 * 24 * 60 * 60 * 1000));
  return `${isoYear}-W${String(week).padStart(2, "0")}`;
}

// Returns the student's weekly XP, treating a stale week as zero so the UI
// never shows last week's number before a fresh attempt resets it.
export function currentWeeklyXp(profile, now = new Date()) {
  if (!profile) return 0;
  return profile.weekKey === weekKey(now) ? profile.weeklyXp || 0 : 0;
}

export function goalProgress(profile, now = new Date()) {
  const goal = profile?.weeklyGoal || DEFAULT_WEEKLY_GOAL;
  const xp = currentWeeklyXp(profile, now);
  return {
    goal,
    xp,
    pct: goal > 0 ? Math.min(100, Math.round((xp / goal) * 100)) : 0,
    met: xp >= goal,
    remaining: Math.max(0, goal - xp),
  };
}
